import React from "react";
import Header from "./Header.js";
import About from "./About.js";

function App() {
  return (
    <div className="App">
      <Header />
      <About />
    </div>
  );
}

export default App;
